"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormattedDate = useFormattedDate;
exports.default = void 0;

var _compact = _interopRequireDefault(require("lodash/compact"));

var _range = _interopRequireDefault(require("lodash/range"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ArrowLeft = _interopRequireDefault(require("@decisiv/iconix/lib/components/ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("@decisiv/iconix/lib/components/ArrowRight"));

var _Button = _interopRequireDefault(require("../../components/Button"));

var _Tooltip = _interopRequireDefault(require("../../components/Tooltip"));

var _Flex = _interopRequireDefault(require("../../components/Flex"));

var _Grid = _interopRequireDefault(require("../../components/Grid"));

var _Typography = require("../../components/Typography");

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _useCalendar2 = _interopRequireDefault(require("./hooks/useCalendar"));

var _DateGrid = _interopRequireWildcard(require("./DateGrid"));

var _focusWithoutScrolling = _interopRequireDefault(require("../../utils/focusWithoutScrolling"));

var _utils = require("./utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useFormattedDate() {
  var translate = (0, _useTranslations.default)();
  var formatDate = (0, _react.useCallback)(function (date) {
    return "".concat(date.getDate(), " ").concat(translate(undefined, "selectDate.monthAbbreviations[".concat(date.getMonth() + 1, "]")), " ").concat(date.getFullYear());
  }, [translate]);
  var formatDateRange = (0, _react.useCallback)(function (dates) {
    if (!dates || (0, _compact.default)(dates).length === 0) return '';

    var _dates = _slicedToArray(dates, 2),
        startDate = _dates[0],
        endDate = _dates[1];

    return "".concat(startDate ? formatDate(startDate) : '', " - ").concat(endDate ? formatDate(endDate) : '');
  }, [formatDate]);
  return {
    formatDate: formatDate,
    formatDateRange: formatDateRange
  };
}

function getActiveRangeModifier(currentDisplayDate, currentActiveDate, selectedDates) {
  if (currentDisplayDate && currentDisplayDate.isInActiveRange) {
    var currentDate = (0, _utils.buildJSDate)(currentDisplayDate);
    var selectedDate = (0, _compact.default)(selectedDates)[0];

    if ((0, _utils.isSameDate)(currentDate, currentActiveDate)) {
      if ((0, _utils.isBeforeDate)(selectedDate, currentDate)) {
        return 'start';
      }

      if ((0, _utils.isAfterDate)(selectedDate, currentDate)) {
        return 'end';
      }
    }

    if (currentDisplayDate.isSelected && currentActiveDate) {
      if ((0, _utils.isBeforeDate)(currentActiveDate, selectedDate)) {
        return 'start';
      }

      if ((0, _utils.isAfterDate)(currentActiveDate, selectedDate)) {
        return 'end';
      }

      if ((0, _utils.isSameDate)(currentActiveDate, selectedDate)) {
        return undefined;
      }
    }

    return 'within';
  }

  return undefined;
}

function getSelectedRangeModifier(currentDisplayDate, selectedDates) {
  var selectedDatesValue = selectedDates;
  if (!selectedDatesValue || (0, _compact.default)(selectedDatesValue).length !== 2) return undefined;
  if (currentDisplayDate && currentDisplayDate.isInSelectedRange) return 'within';
  var currentDate = currentDisplayDate && (0, _utils.buildJSDate)(currentDisplayDate);
  if (currentDate && (0, _utils.isSameDate)(currentDate, selectedDatesValue[0])) return 'start';
  if (currentDate && (0, _utils.isSameDate)(currentDate, selectedDatesValue[1])) return 'end';
  return undefined;
}

var LabelWrapper = (0, _styledComponents.default)(_Typography.P).withConfig({
  displayName: "Calendar__LabelWrapper",
  componentId: "sc-13y7p8y-0"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

function Calendar(props) {
  var focusOnRender = props.focusOnRender,
      width = props.width,
      selected = props.selected,
      viewMonth = props.viewMonth;

  var _useCalendar = (0, _useCalendar2.default)(_objectSpread({}, props, {
    date: viewMonth || selected
  })),
      currentActiveDate = _useCalendar.currentActiveDate,
      dateMatrix = _useCalendar.dateMatrix,
      label = _useCalendar.label,
      setCurrentActiveDate = _useCalendar.setCurrentActiveDate,
      setSelected = _useCalendar.setSelected,
      viewNextMonth = _useCalendar.viewNextMonth,
      viewPrevMonth = _useCalendar.viewPrevMonth,
      viewTodayMonth = _useCalendar.viewTodayMonth;

  var translate = (0, _useTranslations.default)();

  var labelRef = _react.default.useRef(null);

  var firstRender = _react.default.useRef(true);

  var firstTabbableElementRef = _react.default.useRef(null);

  var today = (0, _utils.buildJSDate)(new Date());
  var displayedMonth = dateMatrix[1][1] && dateMatrix[1][1].month;
  var displayedYear = dateMatrix[1][1] && dateMatrix[1][1].year;
  var isCurrentMonth = today.getMonth() + 1 === displayedMonth;
  var isCurrentYear = today.getFullYear() === displayedYear;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTooltip = _useState2[0],
      setShowTooltip = _useState2[1];

  _react.default.useEffect(function () {
    if (focusOnRender && firstRender) {
      firstRender.current = false; // @ts-ignore

      (0, _focusWithoutScrolling.default)(firstTabbableElementRef.current);
    }
  }, [focusOnRender]);

  _react.default.useLayoutEffect(function () {
    var elem = labelRef.current;

    if (elem && elem.clientWidth < elem.scrollWidth) {
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  }, [label]);

  return _react.default.createElement(_Grid.default.Container, {
    paddingY: 1
  }, _react.default.createElement(_Grid.default.Row, {
    alignment: "middle",
    minWidth: "300px",
    width: width,
    paddingBottom: 1
  }, _react.default.createElement(_Grid.default.Column, {
    maxWidth: "calc(100% - 112px)"
  }, _react.default.createElement(LabelWrapper, {
    ref: labelRef
  }, label), showTooltip && _react.default.createElement(_Tooltip.default, {
    target: labelRef
  }, label)), _react.default.createElement(_Flex.default, {
    paddingRight: 1
  }, _react.default.createElement(_Button.default, {
    "aria-label": "",
    onClick: viewTodayMonth,
    ref: firstTabbableElementRef,
    text: translate(undefined, 'calendar.today'),
    size: "small",
    variant: "ghost",
    disabled: isCurrentMonth && isCurrentYear
  })), _react.default.createElement(_Flex.default, {
    paddingRight: 1
  }, _react.default.createElement(_Button.default, {
    "aria-label": translate(undefined, 'calendar.viewPrevMonth'),
    icon: _ArrowLeft.default,
    onClick: viewPrevMonth,
    variant: "ghost"
  })), _react.default.createElement(_Flex.default, {
    paddingRight: 1
  }, _react.default.createElement(_Button.default, {
    "aria-label": translate(undefined, 'calendar.viewNextMonth'),
    icon: _ArrowRight.default,
    onClick: viewNextMonth,
    variant: "ghost"
  }))), _react.default.createElement(_Grid.default.Row, null, _react.default.createElement(_Grid.default.Column, {
    span: "12",
    padding: 0
  }, _react.default.createElement(_DateGrid.default, null, _react.default.createElement("table", null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, (0, _range.default)(0, 7).map(function (dayOfWeekIndex) {
    return _react.default.createElement("th", {
      key: "".concat(label, "-day-of-week-header-idx-").concat(dayOfWeekIndex)
    }, _react.default.createElement(LabelWrapper, {
      as: "span",
      size: "small",
      shade: 1
    }, translate(undefined, "calendar.daysOfWeek[".concat(dayOfWeekIndex, "]"))));
  }))), _react.default.createElement("tbody", {
    onBlur: setCurrentActiveDate(null),
    onMouseLeave: setCurrentActiveDate(null) // eslint-disable-next-line react/jsx-closing-bracket-location

  }, dateMatrix.map(function (week, weekIndex) {
    return (// eslint-disable-next-line react/no-array-index-key
      _react.default.createElement("tr", {
        key: "".concat(label, "-week-").concat(weekIndex)
      }, week.map(function (day, dayIndex) {
        var isDisabled = Boolean(day && day.isDisabled);
        return _react.default.createElement("td", {
          // eslint-disable-next-line react/no-array-index-key
          key: "".concat(label, "-week-").concat(weekIndex, "-day-").concat(dayIndex)
        }, _react.default.createElement(_DateGrid.DateContainer, {
          activeRangeModifier: getActiveRangeModifier(day, currentActiveDate, props.selected),
          selectedRangeModifier: getSelectedRangeModifier(day, props.selected),
          isSelected: Boolean(day && day.isSelected),
          isToday: Boolean(day && day.isToday),
          isDisabled: isDisabled,
          onClick: !isDisabled ? setSelected(day) : undefined,
          onFocus: !isDisabled ? setCurrentActiveDate(day) : undefined,
          onMouseEnter: !isDisabled ? setCurrentActiveDate(day) : undefined
        }, day && _react.default.createElement("button", {
          disabled: isDisabled,
          "aria-disabled": isDisabled,
          type: "button"
        }, _react.default.createElement(LabelWrapper, {
          as: "span",
          color: "inherit"
        }, day.date))));
      }))
    );
  })))))));
}

var _default = Calendar;
exports.default = _default;